import AxiosConfig from './axios.config';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import Mustache from "mustache";
import Utility from '../classes/utility';

// import templates for events
const eventItemInfosessionTemplate = require('../../templates/components/events/event-item-infosession').default;
const eventsInfosessionNoResultsTemplate = require('../../templates/components/events/events-infosession-no-results').default;

const eventsLandingTemplate = require('../../templates/components/events/event-landing-item').default;
const eventsLandingNoresultsTemplate = require('../../templates/components/events/event-landing-item-noresults').default;
const eventsLandingMiniTemplate = require('../../templates/components/events/event-landing-item-mini').default;
const eventsLandingSkeletonTemplate = require('../../templates/components/events/event-landing-item--skeleton').default;

interface EventFilter {
    name: string;
    value: string;
}

class EventsAPI {
    axiosConfig: typeof AxiosConfig;
    resultsContainer: HTMLElement;
    displayType: string;
    eventsRoute: string;
    filters: Array<EventFilter> = [];
    axiosClient: AxiosInstance;
    page: number = 0;

    constructor(resultsContainer: HTMLElement, displayType: string) {
        this.resultsContainer = resultsContainer;
        this.axiosConfig = AxiosConfig;
        this.axiosClient = axios.create(AxiosConfig);
        this.displayType = displayType;
        this.eventsRoute = '/events'
    }

    addFilter(name: string, value: string) {
        let self = this;
        if (this.filters.filter(e => e.name === name).length > 0) {
            if (this.filters.filter(e => e.value === value).length > 0) {
                // do nothing same value
            } else {
                // update value
                for (let index = 0; index < this.filters.length; index++) {
                    if (self.filters[index].name === name) {
                        self.filters[index].value = value;
                        if (value == "") {
                            self.filters.splice(index, 1);
                        }
                    }
                }
            }
        } else {
            // define new filter
            let filterOption: EventFilter = {
                name: name,
                value: value
            }
            self.filters.push(filterOption);
        }
    }

    getFilters(): string {
        let self = this;
        let filterString = "";

        this.filters.forEach((filter, index) => {
            if (index !== self.filters.length - 1) {
                filterString += `${filter.value},`;
            } else {
                filterString += `${filter.value}`;
            }
        });
        return filterString;
    }

    getRequestURL(limit: number, strictQuery: boolean = false): string {
        let needles = "";
        let url = "";

        // compile filters
        if (this.getFilters() == "" && this.resultsContainer.dataset.filters) {
            needles = this.resultsContainer.dataset.filters;
        } else {
            needles = this.getFilters();
            if(this.resultsContainer.dataset.strict == "yes")
            {
                strictQuery = true;
            }
        }

        // define base url
        url = `/api/events/v1/${needles}?limit=${limit}&page=${this.page}`;
        if (strictQuery) {
            url = `/api/events/v1/${needles}?limit=${limit}&page=${this.page}&strictFilter=true`;
        }
        return url;
    }

    get(limit: number, page: number = 0) {
        let self = this;
        this.page = page;

        // skeleton loading
        // self.resultsContainer.innerHTML = Mustache.render(eventsLandingSkeletonTemplate, {});
        // self.resultsContainer.innerHTML += Mustache.render(eventsLandingSkeletonTemplate, {});
        // self.resultsContainer.innerHTML += Mustache.render(eventsLandingSkeletonTemplate, {});

        let selectedTemplate = eventsLandingTemplate;
        let noResultsTemplate = eventsLandingNoresultsTemplate;
        let requestURL = self.getRequestURL(limit);

        if (self.displayType == "mini") {
            selectedTemplate = eventsLandingMiniTemplate;
        } else if (self.displayType == "infosession") {
            selectedTemplate = eventItemInfosessionTemplate;
            noResultsTemplate = eventsInfosessionNoResultsTemplate;
            requestURL = self.getRequestURL(limit, true);
        }
        self.axiosClient.get(requestURL)
            .then(function (response) {
                //self.resultsContainer.querySelectorAll('.event-skeleton').forEach(function(d) { d.remove(); })
                if (response.data.data) {
                    let events = response.data.data as Array<any>;

                    // set maxPages data
                    if (response.data.metaData) {
                        self.resultsContainer.dataset.maxPages = response.data.metaData.pages.lastPage;
                    }
                    if (events) {
                        if (events.length > 0) {
                            if (self.displayType == "infosession") {
                                self.resultsContainer.innerHTML = "";
                            }
                            events.forEach(function(event) {
                                // check for bad chars
                                event.title = Utility.htmlDecode(event.title);
                                event.description =  Utility.htmlDecode(Utility.htmlDecode(event.description));
                                self.resultsContainer.insertAdjacentHTML('beforeend', Mustache.render(selectedTemplate, event));
                            });
                        } else {
                            if (self.displayType == "infosession") {
                                self.resultsContainer.innerHTML = Mustache.render(noResultsTemplate, {});
                            }
                        }
                        // load template images
                        window.lazyload.update();
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                //self.resultsContainer.innerHTML = Mustache.render(noResultsTemplate, {});
            });
    }
}

export default EventsAPI;